import { Icon } from '@orionprotocol/ui';

import { TRY_TO_SWITCH_NETWORK, useAnalytics } from '../../shared/analytics';
import {
  useIsLogged,
  useWalletAddress,
  useWalletChainId,
} from '../../shared/api';
import { useReadOnly } from '../../shared/hooks';

import { ConnectWalletButton } from './ConnectWalletButton';
import styles from './Header.module.scss';
import { HeaderNetwork } from './HeaderNetwork';
import { HeaderWallet } from './HeaderWallet';
import { MainNav } from './MainNav';
import { MobileMenu } from './MobileMenu';
import { NetworksDontMatchWarning } from './NetworksDontMatchWarning';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useTypedDataSignature } from '../../shared/hooks/providers/useTypesDataNew';
import { useEcoDropsStore } from '../../shared/zustand/ecoDropsStore';
import { useGetUser, useUserAuth } from '../../entities/eco-drops/hooks/user';

const TYPES = {
  Request: [
    { name: 'address', type: 'address' },
    { name: 'timestamp', type: 'uint64' },
  ],
};

const DOMAIN = {
  name: 'Lumia',
  version: '1',
  salt: '0x3144f7a6bc6e6c0b06c90779aee302b2d2274ce789511e8b70f37a0e640e2a33',
  chainId: 994873017,
};

export function Header(): JSX.Element {
  const isLogged = useIsLogged();
  const walletChainId = useWalletChainId();
  const walletAddress = useWalletAddress();
  const networksDontMatch = useReadOnly();
  const { sendEvent } = useAnalytics();

  const handleNetworkChanging = (): void => {
    sendEvent(TRY_TO_SWITCH_NETWORK);
  };

  const location = useLocation();
  const isAuthorizingRef = useRef(false);
  const isGovernance = location.pathname.includes('governance');

  return (
    <div className={styles.container}>
      {/* <MobileMenu /> */}

      <Icon icon="logoSimple" className={styles.logoMobile} />
      <Icon icon="logo" className={styles.logoDesktop} />

      <div className={styles.rightContent}>
        {/* <MainNav className={styles.navigation} /> */}

        {walletChainId !== undefined && networksDontMatch && (
          <NetworksDontMatchWarning onNetworkChanging={handleNetworkChanging} />
        )}

        {!isGovernance && <HeaderNetwork />}

        {isLogged ? (
          <HeaderWallet />
        ) : (
          <ConnectWalletButton className={styles.connectWalletButton} />
        )}
      </div>
    </div>
  );
}
